import Cookies from 'js-cookie'
import { useAws } from 'src/networking/aws'
import { AwsGateCallbacks, AwsGateRequest } from 'src/types'
import { PostPayment } from 'src/types/networking/terminals/payment.types'

export const usePostPayment = <
  T extends PostPayment['request'],
  D extends PostPayment['response']
>() => {
  const hook = useAws<T, D>('postPayment')
  return {
    ...hook,
    crossGate: (request: AwsGateRequest<T>, callbacks: AwsGateCallbacks<D>) => {
      request.headers = {
        ...request.headers,
        Authorization: Cookies.get('IdToken') || '',
        xDossierId: request?.header?.dossierId,
      }
      return hook.crossGate(
        {
          method: 'post',
          path: `/payment/${request?.params.idPolizza}`,
          ...request,
        },
        callbacks
      )
    },
  }
}
